import React from 'react';
import { Card, CardImg, CardImgOverlay } from 'reactstrap';
import Css from './ThingsToDoTile.scss';

const Tile = props => {
  return (
    <div className={'mt-4 px-2 col-md col-xs-12'}>
      <Card className={Css.Tile + ' border-0 text-center'}>
        <CardImg
          className="card-img-top"
          src={props.ImgUrl}
          alt="Card image cap"
        />
        <CardImgOverlay
          className={'p-2 text-center d-flex align-items-center ' + Css.Overlay}
        >
          <div className={'align-middle ' + Css.OverlayText}>
            <p className={Css.Header + ' mb-2 font-md'}>{props.FrameHeader}</p>

            <p className={Css.Text + ' font-sm'}>{props.FrameText}</p>
          </div>
        </CardImgOverlay>
      </Card>
    </div>
  );
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/ExperiencesLandingPage/ThingsToDoTile/ThingsToDoTile.js